<template>
    <div>
        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>
        
        <div class="m-6 bg-white shadow-sm rounded-xl border border-gray-100 overflow-hidden">
            <div class="px-4 py-4 sm:px-6 sm:py-5 border-b border-gray-100 flex items-center justify-between gap-4">
                <div class="flex items-center gap-2">
                    <div class="flex items-center justify-between">
                        <div>
                            <h1 class="text-2xl font-semibold text-gray-800">
                                {{ $t('gm.order_analysis_by_agent_client') }}
                            </h1>
                            
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    class="inline-flex items-center gap-1 rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600 hover:bg-gray-200 transition"
                    @click="resetFilters"
                >
                    <span>{{ $t('gm.reset_filters') }}</span>
                </button>
            </div>
            

            <div class="grid grid-cols-1 md:grid-cols-5 gap-4 items-end p-6">
                <!-- DAL -->
                <div>
                    <label class="block text-xs font-medium text-black-600 mb-1">
                        {{ $t('gm.ordered_filter_period_1') }}
                    </label>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.from') }}
                    </label>
                    <input
                        type="date"
                        v-model="fromDatePrimo"
                        @change="onDateChange('p1','from')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <!-- AL -->
                <div>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.to') }}
                    </label>
                    <input
                        type="date"
                        @change="onDateChange('p1', 'to')"
                        v-model="toDatePrimo"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                
                
                <div></div>
                <div>
                    <label class="block text-xs font-medium text-black-600 mb-1">
                        {{ $t('gm.ordered_filter_period_2') }}
                    </label>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.from') }}
                    </label>
                    <input
                        type="date"
                        v-model="fromDateSec"
                        @change="onDateChange('p2', 'from')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <!-- AL -->
                <div>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.to') }}
                    </label>
                    <input
                        type="date"
                        @change="onDateChange('p2', 'to')"
                        v-model="toDateSec"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                
                

                
            </div>

            <!-- CHIP AGENTI SELEZIONATI: SOTTO la riga dei filtri -->
            

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end px-6 pb-6">
                            
                <div v-if="$page.props.isAdminOrSuperAdmin">
                    <label class="block text-xs font-medium text-gray-600 mb-1" >
                        {{ $t('gm.agents_filter') }}
                    </label>
                    <select
                        v-model="agentToAdd"
                        @change="onAgentSelected"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="">{{ $t('gm.all_agents') }}</option>
                        <option
                            v-for="agent in allAgents"
                            :key="agent.code"
                            :value="agent.code"
                        >
                            {{ agent.label }}
                        </option>
                    </select>
                </div>
                
            </div>
            <div
                v-if="selectedAgents.length"
                class=" flex flex-wrap gap-1 pl-6"
            >
                <span
                    v-for="code in selectedAgents"
                    :key="code"
                    class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs text-blue-700"
                >
                    <span>
                        {{ (allAgents.find(a => a.code === code)?.label) || code }}
                    </span>
                    <button
                        v-if="$page.props.isAdminOrSuperAdmin"
                        type="button"
                        class="text-blue-500 hover:text-blue-700"
                        @click="removeSelectedAgent(code)"
                    >
                        ×
                    </button>
                </span>
            </div>


            <div class="p-0">
                <PageServerTable
                    :headers="headers"
                    :items="items"
                    :items-length="total"
                    :loading="loading"
                    :reloadFn="reloadData"
                    :items-per-page="ipp"
                    :page="page"
                    
                >
                    <template #item.ImponOrd="{ item }">
                        <div class="tabular-nums" :class="getColorClass(item.ImponOrd, item)">
                            {{ formatCurrency(item.ImponOrd) }}
                            <div :class="percentColor(item.ImponOrd, item.ImponOrdPrec)" class="text-xs">
                                {{ percentDiff(item.ImponOrd, item.ImponOrdPrec) }}
                            </div>
                        </div>
                    </template>
                    <template #item.ImponOrdPrec="{ item }">
                        <div class="tabular-nums" :class="getColorClass(item.ImponOrdPrec, item)">
                            {{ formatCurrency(item.ImponOrdPrec) }}
                            
                        </div>
                    </template>

                    <template #body.append>
                        <tr class="font-bold bg-gray-50">
                            <td colspan="4" class="text-right py-3 px-4 uppercase text-xs text-gray-500 italic">{{ $t('gm.totals') }}:</td>
                            <td class="py-3 px-4">
                                <div class="tabular-nums">
                                    {{ formatCurrency(totalImponOrd) }}
                                    <div :class="percentColor(totalImponOrd, totalImponOrdPrec)" class="text-xs">
                                        {{ percentDiff(totalImponOrd, totalImponOrdPrec) }}
                                    </div>
                                </div>
                            </td>
                            <td class="py-3 px-4 tabular-nums">
                                {{ formatCurrency(totalImponOrdPrec) }}
                            </td>
                        </tr>
                    </template>

                </PageServerTable>
            </div>
        </div>
    </div>
    
</template>



<script>

    import BreadCrumbs from '@/Components/BreadCrumbs.vue';
    import PageServerTable from '@/Components/PageServerTable.vue';

    export default {
        components: {
            PageServerTable,
            BreadCrumbs
    
        },
        props: {
            loggedAgentCode: {
                type: [String, Number],
                default: null
            }
        },
        data() {
            return {
                navigation: [
                    { name: this.$t('ui.dashboard'), href: route('dashboard') },
                    { name: this.$t('modules.visite-commerciali'), href: route('modules.home', 'visite-commerciali') },
                    { name: this.$t('gm.order_by_sales_person'), href: route('modules.visite-commerciali.ordinato-agente') }
                ], 
                periods: {
                    p1: { from: 'fromDatePrimo', to: 'toDatePrimo' },
                    p2: { from: 'fromDateSec',  to: 'toDateSec' },
                },
                fromDatePrimo : new Date(new Date().getFullYear(), 0, 2).toISOString().slice(0, 10), 
                toDatePrimo : new Date().toISOString().slice(0, 10),
                fromDateSec: new Date(new Date().getFullYear() -1, 0, 2).toISOString().slice(0,10), 
                toDateSec : new Date(new Date().getFullYear() -1, 11, 32).toISOString().slice(0,10), 
                lastValidDates: {},
                dateTimer: null,
                allAgents: [],        
                selectedAgents: [],   
                agentToAdd: '',       
                originalItems: [],
                items: [],
                total: 0, 
                ipp: 10,
                page: 1, 
                loading : false,
                headers : [
                    { title: this.$t('gm.agent'), key: 'agente', value: 'agente'},
                    { title: this.$t('gm.name'), key: 'nome', value: 'nome', filterable: true, filtervalue: ''  },
                    { title: this.$t('gm.client'), key: 'cliente', value: 'cliente' },
                    { title: this.$t('gm.company_name'), key: 'ragsoc', value: 'ragsoc', filterable: true, filtervalue: '' },
                    { title: this.$t('gm.ordered'), key: 'ImponOrd', value: 'ImponOrd' },
                    { title: this.$t('gm.ordered_period_2'), key: 'ImponOrdPrec', value: 'ImponOrdPrec' },
                ],
            }
        },
        computed: {
           
            filteredItems() {
                let data = Array.isArray(this.originalItems) ? this.originalItems : [];
                
                // Applica i filtri locali per ogni header filterable che abbiamo escluso dal server
                const localFilters = this.headers.filter(h => h.filterable && h.filtervalue && (h.key === 'nome' || h.key === 'ragsoc'));

                localFilters.forEach(f => {
                    const q = f.filtervalue.toString().toLowerCase().trim();
                    data = data.filter(row =>
                        (row[f.key] || '').toString().toLowerCase().includes(q)
                    );
                });

                return data;
            },
            totalImponOrd() {
                if (!Array.isArray(this.filteredItems)) return 0;
                return this.filteredItems.reduce((acc, item) => acc + (parseFloat(item.ImponOrd) || 0), 0);
            },
            totalImponOrdPrec() {
                return this.filteredItems.reduce((acc, item) => acc + (parseFloat(item.ImponOrdPrec) || 0), 0);
            }
        },
        methods: {
            reloadData(sortBy, itemsPerPage, page){
                this.loading = true;
                const filters = {};
                this.headers.forEach(h => {
                    if (h.filterable && h.filtervalue && h.key !== 'nome' && h.key !== 'ragsoc') {
                        filters[h.key] = h.filtervalue;  
                    }
                });
                
                if (page) {
                    this.page = page;
                } else {
                    this.page = 1;
                }
                if (itemsPerPage) this.ipp = itemsPerPage; 
                

                
                axios.get(route('modules.visite-commerciali.ordinato-agenti'), { 
                    params: {
                        page : this.page,
                        itemsperpage: this.ipp, 
                        fromDatePrimo: this.fromDatePrimo,
                        toDatePrimo: this.toDatePrimo,
                        fromDateSec : this.fromDateSec,
                        toDateSec : this.toDateSec,
                        agents: this.selectedAgents,
                        ...filters
                    } 

                })
                .then(res => {
                    console.log("Dati ricevuti:", res.data);
                    
                    const allItems = Array.isArray(res.data) ? res.data : (res.data.items || []);
                    const totalItems = res.data.total ?? allItems.length;

                    this.originalItems = allItems;
                    this.total = totalItems;

                    

                    this.applyLocalFiltersAndPagination();
                })
                .finally(() => this.loading = false);

            },

            onAgentSelected() {
                
                if (!this.agentToAdd) {
                    this.selectedAgents = [];
                    return;
                }

                
                if (!this.selectedAgents.includes(this.agentToAdd)) {
                    this.selectedAgents.push(this.agentToAdd);
                }

                
                this.agentToAdd = '';
                this.reloadData(); 
            },

            removeSelectedAgent(code) {
                this.selectedAgents = this.selectedAgents.filter(c => c !== code);
                this.reloadData();
            },

            resetFilters() {
                if (this.dateTimer) clearTimeout(this.dateTimer);
                this.fromDatePrimo =  new Date(new Date().getFullYear(), 0, 2).toISOString().slice(0, 10); 
                this.toDatePrimo = new Date().toISOString().slice(0, 10);
                this.fromDateSec = new Date(new Date().getFullYear() -1, 0, 2).toISOString().slice(0,10), 
                this.toDateSec = new Date(new Date().getFullYear() -1, 11, 32).toISOString().slice(0,10),
                this.headers.forEach(h => {
                    if (h.filterable) h.filtervalue = '';
                }); 
                this.selectedAgents = [];
                this.agentToAdd = '';
                this.reloadData(); 
                this.saveLastValidDates();
            },

            loadAgents() {
                axios.get(route('modules.visite-commerciali.agenti-list'))
                    .then(res => {
                        
                        this.allAgents = res.data;
                    });
            },
            getColorClass(value, item) {
                const n1 = parseFloat(item.ImponOrd)       || 0;
                const n2 = parseFloat(item.ImponOrdPrec)   || 0;
                

                const current = parseFloat(value) || 0;

                const max = Math.max(n1, n2);

                return current === max
                    ? 'text-green-600 font-semibold'
                    : 'text-red-600';
            },

            percentDiff(current, previous) {
                const c = parseFloat(current) || 0;
                const p = parseFloat(previous) || 0;

                if (p === 0) {
                    // Se il precedente è zero:
                    if (c === 0) return '0%';
                    return '+∞%'; // oppure puoi scegliere '+100%' o altro
                }

                const diff = ((c - p) / p) * 100;
                return (diff > 0 ? '+' : '') + diff.toFixed(1) + '%';
            },

            percentColor(current, previous) {
                const c = parseFloat(current) || 0;
                const p = parseFloat(previous) || 0;

                if (p === 0) return 'text-green-600 font-semibold';

                const diff = ((c - p) / p) * 100;

                return diff >= 0
                    ? 'text-green-600 font-semibold'
                    : 'text-red-600 font-semibold';
            },
            applyLocalFiltersAndPagination() {
                const data = this.filteredItems;

                // aggiorno totale (dopo filtro locale)
                this.total = data.length;

                // paginazione locale
                const start = (this.page - 1) * this.ipp;
                const end   = start + this.ipp;
                this.items  = data.slice(start, end);
            },
            getRange(id) {
                const def = this.periods[id];
                return {
                from: this[def.from],
                to:   this[def.to],
                };
            },

            // true se il periodo ha entrambe le date valorizzate
            hasBothDates(id) {
                const r = this.getRange(id);
                return !!(r.from && r.to);
            },

            // true se il periodo ha entrambe le date valorizzate e complete (anno a 4 cifre)
            isDateComplete(dateStr) {
                if (!dateStr) return false;
                const parts = dateStr.split('-');
                if (parts.length !== 3) return false;
                const year = parts[0];
                return year && year.length === 4 && parseInt(year) > 1000;
            },

            // true se from <= to per quel periodo
            isValidRange(id) {
                const r = this.getRange(id);
                if (!this.isDateComplete(r.from) || !this.isDateComplete(r.to)) return false;

                const from = new Date(r.from);
                const to   = new Date(r.to);

                return from <= to;
            },

            // verifica sovrapposizione tra due range {from, to}
            rangesOverlap(a, b) {
                if (!this.isDateComplete(a.from) || !this.isDateComplete(a.to) || !this.isDateComplete(b.from) || !this.isDateComplete(b.to)) return false;

                const A1 = new Date(a.from);
                const A2 = new Date(a.to);
                const B1 = new Date(b.from);
                const B2 = new Date(b.to);

                // A1 <= B2 && B1 <= A2 → sovrapposti
                return A1 <= B2 && B1 <= A2;
            },

            // controlla tutte le coppie di periodi completi
            hasOverlaps() {
                const ids = Object.keys(this.periods);

                // costruiamo array con solo i periodi completi
                const ranges = ids
                .map(id => ({ id, ...this.getRange(id) }))
                .filter(r => this.isDateComplete(r.from) && this.isDateComplete(r.to));

                for (let i = 0; i < ranges.length; i++) {
                for (let j = i + 1; j < ranges.length; j++) {
                    if (this.rangesOverlap(ranges[i], ranges[j])) {
                    return true;
                    }
                }
                }
                return false;
            },

            // chiamata quando cambia una data (Da/A) di un periodo
            onDateChange(id, fieldType) {
                if (this.dateTimer) clearTimeout(this.dateTimer);

                this.dateTimer = setTimeout(() => {
                    const def = this.periods[id];
                    
                    // Se manca una delle due date o non sono complete, non facciamo nulla
                    if (!this.isDateComplete(this[def.from]) || !this.isDateComplete(this[def.to])) {
                        return;
                    }

                    // 1) Controllo bloccante: Da <= A
                    if (!this.isValidRange(id)) {
                        alert(this.$t('gm.date_range_error'));
                        this.restorePeriodDates(id);
                        return;
                    }

                    // 2) Controllo non bloccante: Sovrapposizioni (solo alert)
                    if (this.hasOverlaps()) {
                        alert(this.$t('gm.overlap_error'));
                    }

                    // 3) Salviamo lo stato, reset pagina e ricarichiamo
                    this.saveLastValidDates();
                    this.page = 1;
                    this.reloadData();
                }, 1000);
            },

            saveLastValidDates() {
                const backup = {};
                Object.values(this.periods).forEach(p => {
                backup[p.from] = this[p.from];
                backup[p.to]   = this[p.to];
                });
                this.lastValidDates = backup;
            },

            restorePeriodDates(id) {
                const def = this.periods[id];
                if (!this.lastValidDates || !Object.keys(this.lastValidDates).length) {
                // niente backup? non faccio nulla
                return;
                }

                this[def.from] = this.lastValidDates[def.from] ?? '';
                this[def.to]   = this.lastValidDates[def.to]   ?? '';
            },
        },

        mounted ()
        {        
            if (this.loggedAgentCode) {
                this.selectedAgents = [this.loggedAgentCode];
            }  
            this.loadAgents();
            this.reloadData();
            this.saveLastValidDates();
        },
              
        
    };



</script>